import React, { Component } from 'react'
import Leaves from '../OtherTasks/Leaves';
import TagLabelTable from '../TagLabel/TagLabelTable';
import Grid from '@material-ui/core/Grid';
import WorkType from '../OtherTasks/WorkType';
import Country from '../LinkedTables/Country'
import CRMInputTable from '../LinkedTables/CRMInputTable';
import { getCookie } from '../../utils/CookieHelper';
import Service from '../../config/networkutils'
import { getPrimaryColor } from '../Helper/CommonThings';
import { LoopCircleLoading } from 'react-loadingg';
import { withSnackbar } from 'notistack';

const payrole_api = '/api/pay/role/process/get_pay_role_data/'

const columns = [
    { title: 'Id', field: 'id', editable: 'never' },
    {
        title: 'Name', field: 'name',
    },
]

const token = getCookie("ptd_ts_token");

class OtherInputs extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            data: {}
        }
    }

    componentDidMount() {
        this.fetchData()
    }

    fetchData() {
        let api = `/api/ptd/account/get_crm_inputs_data/?payrole_process=true&distribution_type=true&emp_archive_reason=true`;
        Service.get(api, {
            headers: {
                Authorization: "Token " + token,
            },
        })
            .then(res => {
                this.setState({
                    data: res.data,
                    isLoading: false
                })
            })
            .catch(error => {
                console.log(error)
                this.props.enqueueSnackbar('Something went wrong!', {
                    variant: 'error',
                });
            });
    }
    render() {
        return (
            <div>
                {
                    this.state.isLoading ? <LoopCircleLoading color={getPrimaryColor()} /> :
                        <Grid container spacing={3}>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '50vh', overflowY: 'auto' }}>
                                    <CRMInputTable
                                        tableName="Payrole Process"
                                        api={payrole_api}
                                        upload={false}
                                        access={this.props.access}
                                        isActive={this.props.isActive}
                                        columns={columns}
                                        data={this.state.data ? this.state.data.payrole_process : []}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '50vh', overflowY: 'auto' }}>
                                    <CRMInputTable
                                        tableName="Distribution Type"
                                        api={'/api/sales_status/get_sales_status_data/'}
                                        post_api={'/api/sales_status/'}
                                        upload={false}
                                        access={this.props.access}
                                        isActive={this.props.isActive}
                                        columns={columns}
                                        data={this.state.data ? this.state.data.distribution_type : []}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '50vh', overflowY: 'auto' }}>
                                    <Leaves />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '50vh', overflowY: 'auto' }}>
                                    <WorkType />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '50vh', overflowY: 'auto' }}>
                                    <Country
                                        api={'/api/country/get_country_data/'}
                                        post_api={'/api/country/'}
                                        title={'Country'}
                                    />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '50vh', overflowY: 'auto' }}>
                                    <TagLabelTable />
                                </div>
                            </Grid>
                            <Grid item xs={12} sm={6}>
                                <div style={{ height: '50vh', overflowY: 'auto' }}>
                                    <CRMInputTable
                                        tableName="Archive Reason"
                                        api={'/api/employee/archive/reason/'}
                                        post_api={'/api/employee/archive/reason/create_emp_archive_reason/'}
                                        upload={false}
                                        access={this.props.access}
                                        isActive={this.props.isActive}
                                        columns={columns}
                                        deletable={true}
                                        data={this.state.data ? this.state.data.emp_archive_reason : []}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                }
            </div>
        )
    }
}

export default withSnackbar(OtherInputs);
